export interface Rank {
    id: string;
    name: string;
    scale: number;
    percentPerWord: number;
}

export function nextRank(rank: Rank): Rank {
    let level = Ranks.indexOf(rank);
    if (level < 0) return null;
    level = level + 1;
    if (level >= Ranks.length) return null;
    return Ranks[level];
}

function rank(id: string, name: string, scale: number):Rank {
    return { 
        id: id,
        name: name,
        scale: scale,
        percentPerWord: 100 / (10 * scale)
    }
}

export function rankById(id: string) {
    return Ranks.find(r => r.id == id);
}

export const Ranks = [
    rank("STUD", "Student", 1),
    rank("GRAD", "Graduate", 3),
    rank("CAND", "Doctoral Candidate", 3),
    rank("PHD", "Postdoctoral scholar", 4),
    rank("ADJ", "Adjunct Professor", 4),
    rank("ASST", "Assistant Professor", 4),
    rank("ASSOC", "Associate Professor", 4),
    rank("PROF", "Professor", 4),
    rank("CHAIR", "Department Chair", 4),
    rank("DEAN", "Dean", 4),
    rank("PROV", "Provost", 4),
    rank("PRES", "President", 4),
    rank("MASTER", "Grand Master", 4),
    rank("IMMORT", "Immortal", 50),
    rank("FIN", "Completionist", 100)
]


